/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageBlockTableComparisonColumn = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The DashboardPageBlockTableComparisonColumn model module.
   * @module model/DashboardPageBlockTableComparisonColumn
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DashboardPageBlockTableComparisonColumn</code>.
   * @alias module:model/DashboardPageBlockTableComparisonColumn
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>DashboardPageBlockTableComparisonColumn</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardPageBlockTableComparisonColumn} obj Optional instance to populate.
   * @return {module:model/DashboardPageBlockTableComparisonColumn} The populated <code>DashboardPageBlockTableComparisonColumn</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('FromColumnID')) {
        obj['FromColumnID'] = ApiClient.convertToType(data['FromColumnID'], 'Integer');
      }
      if (data.hasOwnProperty('FromIndicatorID')) {
        obj['FromIndicatorID'] = ApiClient.convertToType(data['FromIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ToColumnID')) {
        obj['ToColumnID'] = ApiClient.convertToType(data['ToColumnID'], 'Integer');
      }
      if (data.hasOwnProperty('ToIndicatorID')) {
        obj['ToIndicatorID'] = ApiClient.convertToType(data['ToIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ComparisonCalculationID')) {
        obj['ComparisonCalculationID'] = ApiClient.convertToType(data['ComparisonCalculationID'], 'Integer');
      }
      if (data.hasOwnProperty('OveruseWarningsEnabled')) {
        obj['OveruseWarningsEnabled'] = ApiClient.convertToType(data['OveruseWarningsEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('CompareToFirstRow')) {
        obj['CompareToFirstRow'] = ApiClient.convertToType(data['CompareToFirstRow'], 'Boolean');
      }
      if (data.hasOwnProperty('BlockID')) {
        obj['BlockID'] = ApiClient.convertToType(data['BlockID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} FromColumnID
   * @default 0
   */
  exports.prototype['FromColumnID'] = 0;
  /**
   * @member {Integer} FromIndicatorID
   */
  exports.prototype['FromIndicatorID'] = undefined;
  /**
   * @member {Integer} ToColumnID
   * @default 0
   */
  exports.prototype['ToColumnID'] = 0;
  /**
   * @member {Integer} ToIndicatorID
   */
  exports.prototype['ToIndicatorID'] = undefined;
  /**
   * @member {Integer} ComparisonCalculationID
   * @default 0
   */
  exports.prototype['ComparisonCalculationID'] = 0;
  /**
   * @member {Boolean} OveruseWarningsEnabled
   * @default false
   */
  exports.prototype['OveruseWarningsEnabled'] = false;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Boolean} CompareToFirstRow
   * @default false
   */
  exports.prototype['CompareToFirstRow'] = false;
  /**
   * @member {Integer} BlockID
   * @default 0
   */
  exports.prototype['BlockID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


